import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Search } from '@local/client-contracts';

@Component({
  selector: 'site-link',
  templateUrl: './site-link.component.html',
  styleUrls: ['./site-link.component.scss'],
})
export class SiteLinkComponent {
  @Input() model: Search.SiteLink;

  @Output() linkClick = new EventEmitter();

  openSiteLink(item: Search.SiteLink, isRoot: boolean) {
    this.linkClick.emit({ item, isRoot });
  }
}
